import { Severity } from 'Data/ViewModels/Core/types';
import { copyTextToClipboard } from 'Lib/clipboard';
import classNames from 'classnames';
import React from 'react';
import coalesce from '../../../Lib/coalesce';
import { withInjectedProps } from '../InjectedPropsContext';

export type ITextAreaProps = Pick<
  React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>,
  'id' | 'maxLength' | 'name' | 'onChange' | 'disabled' | 'readOnly' | 'placeholder' | 'rows' | 'defaultValue'
> & {
  severity?: Severity;
  value?: any;
  copyContentToClipboardLabel?: string;
};

const TextAreaInputBase: React.FC<ITextAreaProps> = ({
  defaultValue,
  disabled,
  readOnly,
  id,
  maxLength,
  name,
  onChange,
  placeholder,
  rows,
  severity,
  value,
  copyContentToClipboardLabel,
}) => {
  const handleChange = (e: any) => {
    e.data = { name, value: e.target.value, submitValues: false };
    onChange?.(e);
  };
  const handleBlur = (e: any) => {
    e.data = { name, value: e.target.value.trim(), submitValues: true };
    onChange?.(e);
  };

  const cx = classNames('TextAreaInput', { [`Input-${severity}`]: !!severity });

  return (
    <>
      <textarea
        className={cx}
        defaultValue={defaultValue === undefined ? defaultValue : coalesce(defaultValue, '')}
        disabled={disabled}
        readOnly={readOnly}
        id={id}
        maxLength={maxLength}
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={placeholder || 'Enter text'}
        rows={rows}
        value={value === undefined ? value : coalesce(value, '')}
      />
      {copyContentToClipboardLabel && (
        <div style={{ textAlign: 'right', paddingTop: '5px' }}>
          <a
            href="about:blank"
            onClick={(e) => {
              e.preventDefault();
              copyTextToClipboard(!!value ? value : ' ');
            }}
          >
            {copyContentToClipboardLabel}
          </a>
        </div>
      )}
    </>
  );
};

const TextAreaInput = withInjectedProps(TextAreaInputBase);

export { TextAreaInput, TextAreaInputBase };
export default TextAreaInput;
